import dompurify from 'dompurify'
import GhostContentAPI, { PostOrPage } from '@tryghost/content-api'
import { useEffect, useState } from 'react'
import { Container, Typography } from '@mui/material'

const api = new GhostContentAPI({
  url: 'https://blog.gemvision.cloud',
  key: 'c3cf0f0c6f8d7dd3b525c072ad',
  version: 'v3.0'
})

const EndOfSupport = () => {
  const [data, updateData] = useState<null | PostOrPage>()
  useEffect(() => {
    const getPost = async () => {
      try {
        const response = await api.posts.read({ id: '6238540e9f113452991b2826' })
        updateData(response)
      } catch (error) {
        return console.error('END OF SUPPORT:', error)
      }
    }
    getPost()
  }, [])
  const sanitizer = (dirty: any) => dompurify.sanitize(dirty, { ADD_TAGS: ['iframe'] })
  return (
    <>
      <Container style={{ textAlign: 'left' }}>
        <Typography variant='h2' gutterBottom>
          {data?.title}
        </Typography>
        <div dangerouslySetInnerHTML={{ __html: sanitizer(data?.html) }}></div>
      </Container>
    </>
  )
}

export default EndOfSupport
